export enum SalesOrderErrorMessageEnum {
  CANCEL_WITH_PAYMENTS = 'You can\'t cancel sales order with created payments',
  CANCEL_WITH_DELIVERY_NOTES = 'You can\'t cancel sales order. Products are used in delivery note(s)',
  INVOICE_GENERATED_ON_SCHEDULE = 'The invoice will be generated to the schedule',
  INVOICE_CREATED_AUTOMATICALLY = 'The invoice will be created automatically',
  INVOICES_CREATED_FOR_ALL_PRODUCTS = 'Outgoing invoices created for all product units',
  DELIVERY_NOTES_CREATED_FOR_ALL_PRODUCTS = 'Delivery notes created for all product units',
}
